import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "flex justify-between items-center mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-green-800" }
const _hoisted_5 = {
  id: "stats-grid",
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
}
const _hoisted_6 = { class: "bg-white p-6 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_9 = { class: "bg-white p-6 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_12 = { class: "bg-white p-6 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_15 = { class: "bg-white p-6 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_18 = {
  id: "recent-activity",
  class: "bg-white rounded-lg shadow-sm border border-gray-200 mb-8"
}
const _hoisted_19 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_20 = {
  key: 1,
  class: "p-8 text-center text-gray-400 text-sm"
}
const _hoisted_21 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_22 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_23 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_25 = { class: "text-sm text-gray-900" }
const _hoisted_26 = { class: "text-xs text-gray-400" }
const _hoisted_27 = { class: "px-6 py-4 text-sm font-mono text-gray-700 max-w-xs" }
const _hoisted_28 = ["title"]
const _hoisted_29 = {
  key: 1,
  class: "text-gray-400 italic"
}
const _hoisted_30 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600" }
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "space-y-5"
}
const _hoisted_35 = { class: "flex flex-wrap gap-3 text-xs" }
const _hoisted_36 = { class: "inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 text-gray-600 font-mono" }
const _hoisted_37 = { class: "inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 text-gray-600 font-mono" }
const _hoisted_38 = { class: "bg-gray-900 text-green-300 text-xs rounded-md p-4 overflow-x-auto whitespace-pre-wrap break-words max-h-52" }
const _hoisted_39 = { class: "bg-gray-900 text-green-300 text-xs rounded-md p-4 overflow-x-auto whitespace-pre-wrap break-words max-h-52" }

import { onMounted, ref } from 'vue';
import Header from '@/components/header.vue';
import SideBar from '@/components/sidebar.vue';
import Modal from '@/components/modal.vue';
import { useAPIKeysStore } from '@/store/apikeys';
import { useRequestStore } from '@/store/requests';
import { useUserStore } from '@/store/users';
import { useAuthStore } from '@/store/auth';
import type { APIRequest } from '@/config/types/responses';


export default /*@__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {

const apiKeysStore = useAPIKeysStore();
const requestStore = useRequestStore();
const userStore = useUserStore();
const authStore = useAuthStore();

const showModal = ref(false);
const selectedRequest = ref<APIRequest | null>(null);

function openModal(req: APIRequest) {
  selectedRequest.value = req;
  showModal.value = true;
}

function formatDate(input: string) {
  if (!input) return '—';
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(date);
}

function formatTime(input: string) {
  if (!input) return '';
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).format(date);
}

function prettyJson(raw: string) {
  if (!raw) return '—';
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

function statusClass(status: string) {
  const code = parseInt(status, 10);
  if (code >= 200 && code < 300) return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700';
  if (code >= 400 && code < 500) return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-700';
  if (code >= 500) return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-red-100 text-red-700';
  return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-gray-100 text-gray-600';
}

onMounted(async () => {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'public') {
    await apiKeysStore.getAPIKeyStats();
    await apiKeysStore.getAPIRequests(1);
    await userStore.fetchUsers(1);
    await requestStore.fetchPhoneValidations(1);
    await requestStore.fetchIDValidations(1);
  } else if (purpose === 'local') {
    await apiKeysStore.getAdminAPIKeyStats();
    await apiKeysStore.getAdminAPIRequests(1);
    await userStore.fetchAdminUsers(1);
    await requestStore.fetchAdminPhoneValidations(1);
    await requestStore.fetchAdminIDValidations(1);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_4, "Hello, " + _toDisplayString(_unref(authStore).user.firstName || 'User'), 1),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mt-1 text-gray-600" }, "Welcome to your console dashboard", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm font-medium text-gray-500" }, "Active API Keys", -1)),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(apiKeysStore).activekeysCount ?? 0), 1),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-green-600 mt-1" }, [
                  _createElementVNode("i", { class: "fa-solid fa-key mr-1" }),
                  _createTextVNode(" API keys currently active ")
                ], -1))
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-blue-100 p-3 rounded-full" }, [
                _createElementVNode("i", { class: "fa-solid fa-key text-blue-600 text-xl" })
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm font-medium text-gray-500" }, "Monthly API Usage", -1)),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(apiKeysStore).monthlyUsageCount ?? 0), 1),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-green-600 mt-1" }, [
                  _createElementVNode("i", { class: "fa-solid fa-chart-line mr-1" }),
                  _createTextVNode(" Requests this month ")
                ], -1))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg-green-100 p-3 rounded-full" }, [
                _createElementVNode("i", { class: "fa-solid fa-chart-line text-green-600 text-xl" })
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-medium text-gray-500" }, "Phone Validations", -1)),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(requestStore).phoneNumberResults?.length ?? 0), 1),
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm text-green-600 mt-1" }, [
                  _createElementVNode("i", { class: "fa-solid fa-phone mr-1" }),
                  _createTextVNode(" Phone numbers verified ")
                ], -1))
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bg-purple-100 p-3 rounded-full" }, [
                _createElementVNode("i", { class: "fa-solid fa-phone text-purple-600 text-xl" })
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-sm font-medium text-gray-500" }, "Active Users", -1)),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(userStore).users?.length ?? 0), 1),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm text-green-600 mt-1" }, [
                  _createElementVNode("i", { class: "fa-solid fa-users mr-1" }),
                  _createTextVNode(" Registered users ")
                ], -1))
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bg-orange-100 p-3 rounded-full" }, [
                _createElementVNode("i", { class: "fa-solid fa-users text-orange-600 text-xl" })
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "px-6 py-4 border-b border-gray-200 flex justify-between items-center" }, [
            _createElementVNode("h3", { class: "text-lg font-semibold text-gray-800" }, "Recent API Requests"),
            _createElementVNode("a", {
              href: "/apirequests",
              class: "text-green-600 text-sm font-medium hover:text-green-700"
            }, "View All")
          ], -1)),
          (_unref(apiKeysStore).loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[14] || (_cache[14] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (!_unref(apiKeysStore).apiRequests?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " No recent requests "))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("table", _hoisted_22, [
                    _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Timestamp"),
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Endpoint"),
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Organization"),
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "HTTP Status"),
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Details")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(apiKeysStore).apiRequests.slice(0, 5), (req) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: req.id,
                          class: "hover:bg-gray-50 transition-colors"
                        }, [
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, _toDisplayString(formatDate(req.createdAt)), 1),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(formatTime(req.createdAt)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            (req.endpoint)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  title: req.endpoint,
                                  class: "block truncate max-w-xs cursor-default"
                                }, _toDisplayString(req.endpoint), 9, _hoisted_28))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, "No endpoint"))
                          ]),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(req.orgnizationName || '—'), 1),
                          _createElementVNode("td", _hoisted_31, [
                            _createElementVNode("span", {
                              class: _normalizeClass(statusClass(req.httpStatus))
                            }, _toDisplayString(req.httpStatus || '—'), 3)
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (openModal(req)),
                              class: "inline-flex items-center px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50 border border-green-200 rounded-md hover:bg-green-100 transition-colors"
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "fa-solid fa-code mr-1.5" }, null, -1),
                              _createTextVNode(" View Payload ", -1)
                            ]), 8, _hoisted_33)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
        ]),
        _createVNode(Modal, {
          show: showModal.value,
          title: "Request & Response Payload",
          size: "max-w-3xl",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false))
        }, {
          default: _withCtx(() => [
            (selectedRequest.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, [
                      _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa-solid fa-clock mr-1.5 text-gray-400" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(formatDate(selectedRequest.value.createdAt)) + " " + _toDisplayString(formatTime(selectedRequest.value.createdAt)), 1)
                    ]),
                    _createElementVNode("span", _hoisted_37, [
                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa-solid fa-link mr-1.5 text-gray-400" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(selectedRequest.value.endpoint || 'No endpoint'), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(['inline-flex items-center px-2.5 py-1 rounded-md font-semibold', statusClass(selectedRequest.value.httpStatus)])
                    }, _toDisplayString(selectedRequest.value.httpStatus || '—'), 3)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center" }, [
                      _createElementVNode("i", { class: "fa-solid fa-arrow-up-from-bracket mr-2 text-blue-400" }),
                      _createTextVNode("Request ")
                    ], -1)),
                    _createElementVNode("pre", _hoisted_38, _toDisplayString(prettyJson(selectedRequest.value.request)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center" }, [
                      _createElementVNode("i", { class: "fa-solid fa-arrow-down-to-bracket mr-2 text-emerald-400" }),
                      _createTextVNode("Response ")
                    ], -1)),
                    _createElementVNode("pre", _hoisted_39, _toDisplayString(prettyJson(selectedRequest.value.response)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ])
  ], 64))
}
}

})